import React, { useEffect, useState } from "react";
import { Alert, Button } from "react-bootstrap";
import { reviewApi } from "./api";
export default function BetaOperations({ revision }: { revision: number }) {
  const [data, setData] = useState<any>(null),
    [error, setError] = useState(""),
    [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const c = new AbortController();
    setError("");
    reviewApi("/beta/operations", "GET", undefined, c.signal)
      .then(setData)
      .catch(e => {
        if (!c.signal.aborted) setError(e.message);
      });
    return () => c.abort();
  }, [revision, attempt]);
  return (
    <section className="reviewed-note mb-4" aria-label="Beta operations">
      <h2 className="h5">Beta health</h2>
      {error ? (
        <Alert variant="warning">
          {error}{" "}
          <Button variant="link" onClick={() => setAttempt(n => n + 1)}>
            Retry
          </Button>
        </Alert>
      ) : data ? (
        <>
          <p className="small">
            {data.scope}. Updated{" "}
            {new Date(data.observedAt).toLocaleTimeString()}.
          </p>
          <p className="small">
            Last successful reminder sweep:{" "}
            {data.worker?.last_success_at
              ? new Date(data.worker.last_success_at).toLocaleString()
              : "not yet recorded"}
            . Reviewers needing participation confirmation:{" "}
            {data.staleParticipation}. Stalled emails:{" "}
            {(data.email.review_stalled || 0) +
              (data.email.account_stalled || 0)}
            .
          </p>
          <div className="review-stats">
            <div>
              <strong>{data.reviews.waiting_match}</strong>Waiting for a match
            </div>
            <div>
              <strong>{data.reviews.overdue}</strong>Overdue
            </div>
            <div>
              <strong>{data.attention.unresolved_conflicts}</strong>Unresolved
              conflicts
            </div>
            <div>
              <strong>{data.attention.pending_refunds}</strong>Refunds pending
            </div>
            <div>
              <strong>
                {data.email.review_failed + data.email.account_failed}
              </strong>
              Failed emails
            </div>
          </div>
          <p className="small">
            Submitted {data.reviews.submitted} · assigned{" "}
            {data.reviews.assigned} · agreed {data.reviews.agreed} · delivered{" "}
            {data.reviews.delivered} · closed {data.reviews.closed}. Feedback:{" "}
            {data.feedback.count}
            {data.feedback.average
              ? `, average ${Number(data.feedback.average).toFixed(1)}/5`
              : ""}
            . Median matching:{" "}
            {data.reviews.median_matching_hours != null
              ? `${Number(data.reviews.median_matching_hours).toFixed(1)} hours`
              : "not enough data"}
            .
          </p>
          <p className="small mb-0">
            Check this queue daily. Reminders run every minute; matching and
            acceptance escalate after 24 hours, delivery reminders begin 12
            hours before the due time. Use Manage to reassign or end a review.
            Failed emails require delivery-log investigation.
          </p>
        </>
      ) : (
        <p role="status">Loading beta health…</p>
      )}
    </section>
  );
}
